import { cn } from "@src/lib/utils/cn";

// A loading placeholder. The fill is an alpha token so it reads on any
// surface in both themes; the pulse stops under prefers-reduced-motion.
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): React.ReactElement {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-skeleton motion-reduce:animate-none",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
